<template>
  <div class="itemCheckbox">
    <label class="item">
      <div class="item-checkbox">
        <input
          class="checkbox-input"
          type="checkbox"
          ref="checkbox"
          @click="handleClick"
          v-model="itemCheckbox"
          :name="data.pool_code"
          :value="data.jan_code"
        />
        <div class="checkbox-icon"></div>
      </div>
      <div class="item-image">
        <img
          :src="productImagePath"
          :alt="`${data.product_name}の商品画像`"
          width="80"
          height="80"
          loading="lazy"
        />
      </div>
      <div class="item-textWrapper">
        <div class="item-left">
          <h4 class="item-nameWrapper">
            <span class="item-brand">{{ brandName }}</span>
            <span class="item-name">{{ data.product_name }}</span>
          </h4>
          <div class="item-review">
            <Review
              :id="data.pool_code"
              :poolCode="data.pool_code"
              :analyticsPrefix="'step2_review'"
            />
          </div>
        </div>
        <div class="item-right">
          <div class="item-price price">
            <span class="price-contents">{{ data.hyoji_yo_naiyo_ryo }}</span>
            <span class="price-value">{{
              data.komi_kkk | toLocaleString
            }}</span>
            <span class="price-text">円（税込）</span>
          </div>
          <div class="item-ranking">
            <RankingIcon :number="data.ranking_num" />
          </div>
        </div>
      </div>
    </label>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { IMAGE_PATH } from "../../../config/IMAGE_PATH";
import Review from "../../ui/Review.vue";
import RankingIcon from "../../ui/RankingIcon.vue";
import { adobeClickEvent } from "../../../modules/analytics";

export default {
  name: "ItemCheckbox",
  components: { Review, RankingIcon },
  data() {
    return {
      ranking: 10,
    };
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters("product", ["selectedProductIds"]),
    ...mapGetters("jsonData", ["tables"]),
    brandName() {
      return this.tables["brand_names"][this.data.brand_name];
    },
    itemCheckbox: {
      get() {
        return this.selectedProductIds;
      },
      set(value) {
        this.$store.dispatch("product/setSelectedProductIds", { value });
      },
    },
    productImagePath() {
      return IMAGE_PATH + this.data.shohin_pl_c_gzfl_pth;
    },
  },
  methods: {
    analyze(eventId, url) {
      adobeClickEvent(eventId, url);
    },
    handleClick(e) {
      const targetTagName = e.target.tagName.toLowerCase();
      if (targetTagName === "a") return; // reviewリンクのクリック時は発火しないようにする。
      this.analyze(`step2_${this.data.pool_code}`);
    },
  },
};
</script>
<style lang="scss" scoped>
.itemCheckbox {
  width: 100%;
  .item {
    width: 100%;
    padding: 10px 12px 9px 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
  }

  .item-checkbox {
    position: relative;
    margin-right: 35px;

    .checkbox-input {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
    }

    .checkbox-icon {
      &::before {
        $size: 15px;
        content: "";
        display: block;
        width: $size;
        height: $size;
        border-radius: 3px;
        background-color: #fff;
        border: 1px solid #dddddd;
      }

      &::after {
        content: "";
        display: block;
        position: absolute;
        width: 11px;
        height: 13px;
        background: url("../../../assets/images/_parts/other/check.svg")
          no-repeat center/contain;
        left: 5px;
        top: -1px;
        visibility: hidden;
      }
    }

    .checkbox-input:checked + .checkbox-icon::after {
      visibility: visible;
    }
  }

  .item-image {
    width: 80px;
    height: 80px;
    flex-shrink: 0;
    & > img {
      object-fit: contain;
    }
  }

  .item-textWrapper {
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    align-items: center;
    margin-left: 20px;
  }

  .item-left {
    display: flex;
    align-items: center;
  }
  .item-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .item-nameWrapper {
    /* flex-grow: 1; */
    width: 360px;
    text-align: left;
    margin-right: 10px;
    word-break: break-all;
  }

  .item-brand {
    font-size: 12px;
    display: block;
    font-weight: 400;
  }
  .item-name {
    font-size: 14px;
    font-weight: 600;
    /* margin-top: 12px; */
    display: block;
    line-height: 1.4;
    margin-top: 2px;
  }

  .item-review {
    flex-shrink: 0;
  }

  .item-price {
  }

  .price {
    text-align: right;
    flex-shrink: 0;
    width: 170px;
    /* margin-left: 10px; */
    flex-shrink: 0;
  }

  .price-contents {
    font-size: 12px;
    margin-right: 5px;
  }

  .price-value {
    font-size: 14px;
    font-weight: 600;
  }

  .price-text {
    font-size: 12px;
  }

  .item-ranking {
    margin-left: 26px;
    flex-shrink: 0;
    min-width: 44px;
    display: flex;
    justify-content: center;
  }

  @include media() {
    .item {
      width: 100%;
      padding: vw(4) 0 vw(3);
    }

    .item-checkbox {
      margin-right: vw(15);
    }

    .item-image {
      width: vw(70);
      height: vw(70);
    }

    .item-left {
      display: block;
    }
    .item-right {
      display: block;
    }

    .item-textWrapper {
      display: block;
      flex-grow: 1;
      position: relative;
      margin: 0;
      margin-left: vw(10);
    }

    .item-nameWrapper {
      margin: 0;
    }

    .item-nameWrapper {
      /* flex-grow: 1;
      width: 360px;
      text-align: left;
      margin-right: 10px;
      word-break: break-all; */
      width: auto;
      margin-right: 0;
    }
    .item-brand {
      font-size: vw(10);
    }
    .item-name {
      font-size: vw(11);
      margin-top: vw(2);
    }

    .item-review {
      margin-top: vw(1);
    }

    .item-price {
      margin: 0;
      /* margin-top: vw(0); */
    }

    .price {
      text-align: left;
      width: auto;
    }

    .price-contents {
      font-size: vw(10);
      margin-right: vw(5);
    }

    .price-value {
      font-size: vw(11);
      line-height: 1.4;
      /* font-weight: 600; */
    }

    .price-text {
      font-size: vw(10);
    }

    .item-ranking {
      margin: 0;
      position: absolute;
      bottom: vw(6);
      right: 0;
    }
  }
}
</style>
